import fipeApi from '../../config/external/fipeApi';
import { CarFipeInfoResponse } from '../../interfaces/CarInfoResponse';

const RefreshSearchService = async (url: string): Promise<CarFipeInfoResponse> => {
  const response = await fipeApi.get(url);
  return response.data;
};

export default RefreshSearchService;
